import Main from './main';
import Single from './single';

const routes = [
  {
    path: '/*',
    Component: Main,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id',
    Component: Single,
    props: {
      exact: true,
    },
  },
];

export default routes;
